import React from 'react'
import useThrottle from 'react-use/lib/useThrottle'
import searchOnAlgolia from './searchOnAlgolia'
import useSuspendedLoadingState from '../useSuspendedLoadingState'

import Entry from '../SearchEntryRecord'

function createNoteEntry(hit) {
  return Entry({
    key: `note-${hit.objectID}`,
    type: 'notes',
    data: {
      id: hit.objectID,
      ...hit,
    },
    searchToken: hit.title,
    channelId: hit.channelId,
  })
}

export default function useFullTextSearchResults({
  query,
  algoliaClient,
  organization,
  snippetContentLength,
}) {
  const queryRef = React.useRef()
  queryRef.current = query
  const [isLoading, setIsLoading] = useSuspendedLoadingState(true)
  const [results, setResults] = React.useState([])
  const throttledQuery = useThrottle(query, 60)

  React.useEffect(
    () => {
      const throttledSearch = async () => {
        setIsLoading(true)
        const hits = await searchOnAlgolia({
          query: throttledQuery,
          client: algoliaClient,
          organization,
          snippetContentLength,
        })

        // discard results if query has changed
        if (queryRef.current !== query) {
          return
        }

        const results = hits.map(createNoteEntry)
        setIsLoading(false)
        setResults(results)
      }
      throttledSearch()
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [throttledQuery]
  )

  return [results, isLoading]
}
